module.exports = __webpack_public_path__ + "img/BLANCO_Training.268b4bbb.png";